import { render } from "./loading.vue?vue&type=template&id=b68e391c"
import script from "./loading.vue?vue&type=script&lang=ts"
export * from "./loading.vue?vue&type=script&lang=ts"
script.render = render

export default script